<section class="not-found-section">
  <div class="not-found-container floating">
    <h1 class="not-found-title" *ngIf="context === undefined">{{ "page.notFound.error.general" | translate }}</h1>
    <h1 class="not-found-title" *ngIf="context === NotFoundContext.verifyTokenExpired">
      {{ "page.notFound.error.confirmationLinkExpired" | translate }}
    </h1>
    <p class="not-found-subtitle">
      <img src="app/shared/assets/images/404_error.svg" alt="Image of a 404 error" />
    </p>
    <a routerLink="/landing" class="not-found-button" style="cursor: pointer">{{ "common.returnHome" | translate }}</a>
  </div>
</section>
